<template>
  <div>
    <div id="vrpc" class="vrpc-warp">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" class="vrpc-box" v-for="(item, index) in list" :key="index">
          <div id="vr_bar1" class="vr-box" @click="JupUrlVR(item)">
            <div style="width: 100%;height: 100%;">
              <img style="width: 100%;height: 100%;" :src="item.fileUrl" />
            </div>
            <div class="vr-title">{{item.title}}</div>
          </div>
        </el-col>
        <!-- <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" class="vrpc-box">
          <div id="vr_bar1" class="vr-box" @click="JupUrlVR1">
            <div style="width: 100%;height: 100%;">
            	<img style="width: 100%;height: 100%;" src="../../assets/img/v-1.png" />
            </div>
            <div class="vr-title">唐蕃古道</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" class="vrpc-box">
          <div id="vr_bar1" class="vr-box" @click="JupUrlVRYD">
            <div style="width: 100%;height: 100%;">
            	<img style="width: 100%;height: 100%;" src="../../assets/img/ydyl.jpg" />
            </div>
            <div class="vr-title">山宗·水源·路之冲</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" class="vrpc-box">
          <div id="vr_bar1" class="vr-box" @click="JupUrlVRMJ">
            <div style="width: 100%;height: 100%;">
            	<img style="width: 100%;height: 100%;" src="../../assets/img/MJ.jpg" />
            </div>
            <div class="vr-title">青海民族民间艺术展</div>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <div id="vrmobile">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: []
      }
    },
    methods: {
      JupUrlVR: function(url) {
        window.open(url.vrUrl)
      },
      // JupUrlVR1: function() {
      //   window.open("http://www.qhmuseum.cn/vr/tbgd/index.html")
      // },
      // JupUrlVRYD: function() {
      //   window.open("https://720yun.com/t/6b5jr5yuuO8")
      // },
      // JupUrlVRMJ: function() {
      //   window.open("https://case.11dom.com/qinghai/index.html?m=7c7eed1a_IUzq_b6f9&o=1")
      // },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        let eWidth = document.getElementById("vr").offsetWidth;
        for (var i = 1; i < 8; i++) {
          document.getElementById("vr_bar" + i + "").style.width = eWidth / 4 - 10 + "px";
        }
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/vr/getVrList';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          that.list = result.data.data
          console.log(that.list)
        }).catch(function(error) {
          console.log(err);
        })
      },
    },
    mounted() {
      this.search()
    }
  }
</script>

<style scoped>
  .vrpc-warp {
    margin: 0 20px;
  }

  .vr-box {
    float: left;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height: 300px;
  }

  .vr-title {
    width: 100%;
    height: 40px;
    position: absolute;
    z-index: 999;
    bottom: 1%;
    background: rgba(149, 111, 23, 0.5);
    color: rgb(255, 255, 255);
    line-height: 40px;
    font-size: 0.875rem;
  }

  .vrpc-box {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/exhibitioninfo/vr.vue